import { Directive, ElementRef, OnInit, Input, DoCheck } from '@angular/core';
import { I18NService } from './I18NService';

@Directive({
	selector: '[i18n]',
	standalone: false,
})
export class I18NDirective implements OnInit, DoCheck {
	@Input('i18n') eight: any;
	@Input() eikey: string;
	@Input() args: any;
	@Input() count = -1;
	private element: any;

	constructor(private elementWrapper: ElementRef) {
		this.element = this.elementWrapper.nativeElement;
	}

	ngOnInit(): void {
		const message: string = I18NService.getMessage(this.eikey, this.args, this.count);

		if (message) {
			this.element.innerHTML = message;
		} else {
			console.warn(`i18n directive eikey: ${this.eikey}, not found.`);
		}
	}

	ngDoCheck(): void {
		if (this.args || this.count !== -1) {
			const message: string = I18NService.getMessage(this.eikey, this.args, this.count);
			if (message) {
				this.element.innerHTML = message;
			} else {
				console.warn(`i18n directive key: ${this.eikey}, not found.`);
			}
		}
	}
}
